import { Instagram } from 'lucide-react';

import { platformLabel, type AccountPlatform } from '../../../entities/account';

// Платформа берётся из общего реестра (entities/account/model/platforms.ts),
// чтобы новая сеть заводилась в одном месте.
export type Platform = AccountPlatform;

/**
 * Метка платформы рядом с ником в списках и таблицах.
 *
 * Только логотип: слово «Instagram» стояло в каждой строке и занимало больше
 * места, чем сам ник, ничего к нему не добавляя. Название остаётся в
 * подсказке и для читалок экрана — и целиком показывается у сетей, для
 * которых у нас нет узнаваемого значка.
 */
export function PlatformBadge({ platform }: { platform: Platform }) {
  const label = platformLabel(platform);

  if (platform !== 'instagram' && platform !== 'tiktok') {
    return (
      <span className="inline-flex items-center gap-1 rounded-full border border-border bg-muted px-2 py-0.5 text-[11px] font-medium leading-none">
        {label}
      </span>
    );
  }

  return (
    <span
      role="img"
      aria-label={label}
      title={label}
      className="inline-flex shrink-0 items-center text-muted-foreground"
    >
      {platform === 'tiktok' ? (
        // У lucide нет глифа TikTok — рисуем ноту сами.
        <svg className="size-3.5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M16.5 3c.3 2 1.6 3.6 3.5 3.9v2.5c-1.3.1-2.5-.3-3.6-1v6.1a5.5 5.5 0 1 1-5.5-5.5c.3 0 .6 0 .9.1v2.6a2.9 2.9 0 1 0 2 2.8V3h2.7z" />
        </svg>
      ) : (
        <Instagram className="size-3.5" />
      )}
    </span>
  );
}
